/**
 * 第五階段（西門包）：西門町和艋舺龍山寺／萬華。
 * 標示「英文練習」的句子在所有語言中都刻意保留英文。
 */
import type { Messages } from './en';

export const zhTWXimen: Pick<Messages, 'ximen'> = {
  ximen: {
    mapNames: {
      ximen: '西門町',
      longshan: '艋舺龍山寺',
    },
    zones: {
      ximen: '西門町',
      longshan: '艋舺龍山寺・萬華',
      xmCinemaPark: '台北電影主題公園',
      xmCinemaStreet: '電影街',
      xmSquare: '街頭藝人廣場',
      xmEmei: '峨嵋街',
      xmExit6: '捷運西門站・6號出口',
      xmRedHouse: '西門紅樓',
      xmChengdu: '成都路',
      xmZhonghua: '中華路',
      xmTemple: '艋舺龍山寺',
      xmHerbAlley: '青草巷',
      xmHuaxi: '華西街夜市',
      xmBopiliao: '剝皮寮歷史街區',
      xmOldWanhua: '老萬華',
      xmBangka: '艋舺公園',
    },
    objects: {
      xm_exit6: '捷運6號出口',
      xm_mapBoard: '街區地圖',
      xm_meesua: '麵線攤',
      xm_chicken: '雞排攤',
      xm_ice: '剉冰店',
      xm_sticker: '大頭貼機',
      xm_tea: '珍珠奶茶店',
      xm_claw: '夾娃娃機',
      xm_cinema: '電影院售票口',
      xm_posters: '電影海報',
      xm_sneakers: '球鞋架',
      xm_clothes: '衣服架',
      xm_tattoo: '刺青店招牌',
      xm_busker: '街頭藝人',
      xm_screen: '巨型電視牆',
      xm_plaque: '西門町地面標誌',
      xm_graffiti: '塗鴉牆',
      xm_redHouse: '西門紅樓',
      xm_market: '週末創意市集',
      xm_mrtL: '捷運龍山寺站',
      xm_dragonDoor: '龍門（入口）',
      xm_pillar: '銅鑄龍柱',
      xm_waterfall: '瀑布庭園',
      xm_burner: '天公爐',
      xm_offer: '供桌',
      xm_moon: '筊杯',
      xm_sticks: '籤筒',
      xm_roof: '燕尾脊',
      xm_herbTea: '青草茶攤',
      xm_herbSign: '青草巷招牌',
      xm_bopiliao: '剝皮寮歷史解說牌',
      xm_huaxi: '華西街牌樓',
      xm_hxNoodle: '擔仔麵攤',
      xm_hxSoup: '四神湯攤',
      xm_chess: '象棋桌',
      xm_pigeons: '鴿子',
      xm_canoe: '獨木舟雕塑',
      xm_fortune: '算命攤',
      xm_oldIce: '老冰店',
    },
    npc: {
      xm_teen1: '等朋友的少年',
      xm_teen2: '滑手機的少年',
      xm_teen3: '戴帽子的少年',
      xm_meesuaLady: '麵線阿姨',
      xm_tourist: '迷路的觀光客',
      xm_shopper1: '逛街的人',
      xm_shopper2: '球鞋迷',
      xm_skater: '滑板少年',
      xm_artist: '市集手作藝術家',
      xm_redGuide: '紅樓導覽員',
      xm_cosplayer: 'Cosplay玩家',
      xm_grandpaX: '老影迷',
      xm_volunteer: '廟宇志工',
      xm_fortuneGrandpa: '算命阿公',
      xm_worshipper1: '信眾',
      xm_worshipper2: '拿香的阿嬤',
      xm_incenseAuntie: '賣香阿姨',
      xm_herbLady: '青草茶阿姨',
      xm_chess1: '下棋阿公',
      xm_chess2: '看棋的人',
      xm_pigeonKid: '看鴿子的小孩',
      xm_bopiliaoGuide: '歷史系學生',
      xm_nightVendor: '夜市廚師',
      xm_tourist2: '外國遊客',
      xm_taichi: '打太極的阿嬤',
    },
    items: {},

    common: {
      learned: '📘 你學到新東西了！',
      closed: '現在還沒開。夜市晚上才營業（下午5點起）。',
      notEnough: '你的金幣不夠。',
      back: '返回',
    },

    // --- 西門町 ---------------------------------------------------------------------------
    exit6: {
      text: '捷運西門站6號出口：臺北最有名的約會地點。每到週末，年輕人都在這裡等朋友。',
      phrase: 'Let’s meet at Exit 6!', // English practice
      ride: '🚇 搭捷運',
      practice: '🗣️ 練習用英文約見面',
      q: 'Your friend asks: “Where shall we meet?”', // English practice
      a: ['Let’s meet at Exit 6 at three o’clock.', 'Meet you yesterday at the train.', 'I am Exit 6.'], // English practice
      right: '✅ 太棒了！要說出地點和時間。你的朋友回答：「See you there!」',
      wrong: '嗯，聽起來怪怪的。要說出地點和時間喔！',
    },
    mapBoard: {
      text: '西門町地圖：上面是電影街，中間是峨嵋街，下面是6號出口和西門紅樓。',
      q: 'You are at Exit 6. How do you go to the Red House?', // English practice
      a: ['Cross Chengdu Road. It’s on the other side.', 'Take the escalator up to the sky.', 'Go inside the cinema.'], // English practice
      right: '✅ 對！西門紅樓就在6號出口的馬路對面。',
      wrong: '再看一次地圖：紅色的建築在大馬路對面。',
    },
    meesua: {
      vendor: 'Hello! Big bowl or small bowl?', // English practice
      ok: 'A small bowl of mee sua, please.', // English practice
      bad: ['Give me noodle now!', 'I am a small bowl.'], // English practice
      done: 'Here you go! Here we eat it standing up, with a spoon — no chopsticks. Careful, it’s hot!', // English practice
      after: '麵線是細細的麵線湯，加了大腸和很多蒜頭。這裡沒有座位：大家都站在街上吃！',
    },
    tea: {
      vendor: 'Hi! What would you like? How sweet, and how much ice?', // English practice
      ok: 'A bubble milk tea, half sugar, less ice, please.', // English practice
      bad: ['Sugar me, please!', 'I want a hot ice cold tea big.'], // English practice
      done: 'One bubble milk tea, half sugar, less ice! Shake it before you drink!', // English practice
    },
    chicken: {
      vendor: 'Welcome! Spicy or not spicy? Shall I cut it?', // English practice
      ok: 'One chicken cutlet, not spicy, cut, please.', // English practice
      bad: ['Chicken! Chicken! Chicken!', 'Not cut spicy me chicken.'], // English practice
      done: 'Here you are! It’s bigger than your face!', // English practice
    },
    ice: {
      vendor: 'Hello! Mango or strawberry shaved ice?', // English practice
      ok: 'Could I have a mango shaved ice, please?', // English practice
      bad: ['Mango me!', 'I would like a hot snow, please.'], // English practice
      done: 'One mango shaved ice! It’s big — share it with a friend!', // English practice
    },
    claw: {
      text: '一整間都是夾娃娃機！玩一次10枚金幣。爪子很難抓喔！',
      play: '🧸 玩一次（10枚金幣）',
    },
    cinema: {
      text: '一百年來，西門町一直是臺北的電影街。你想看哪一部電影？',
      films: ['Space Cat', 'Boba Quest', 'Robo Fu'],
      vendor: 'Hi! Which movie, and how many tickets?', // English practice
      ok: 'One ticket for {film}, please.', // English practice
      bad: ['Movie! One! Me!', 'I am a ticket for {film}.'], // English practice
      done: 'Here’s your ticket for {film}. Enjoy the movie!', // English practice
      watched: '🍿 你看了《{film}》。好好看的電影！',
    },
    posters: {
      text: 'Three posters: SPACE CAT — “A brave cat flies to the moon.” BOBA QUEST — “Two friends look for the best bubble tea.” TYPHOON! — “A family stays home in the storm.”', // English practice
      q: 'Who flies to the moon?', // English practice
      a: ['A brave cat.', 'Two friends.', 'A family.'], // English practice
      right: '✅ 答對了！《Space Cat》講的是一隻勇敢的貓。',
      wrong: '再讀一次海報！',
    },
    sneakers: {
      text: '一排排五顏六色的球鞋。你喜歡的那雙太小了……',
      q: 'How do you ask for another size?', // English practice
      a: ['Do you have these in a bigger size?', 'Shoes bigger you have?', 'I size the shoes, please.'], // English practice
      right: '✅ 很好！店員笑著說：「Sure, let me check!」', // English practice
      wrong: '試試看用「Do you have…?」有禮貌地問。',
    },
    clothes: {
      text: '特價架上有各種顏色的T恤。你喜歡那件黃色的。',
      q: 'How do you ask to try it on?', // English practice
      a: ['Can I try this on, please?', 'I try you on.', 'This is on me?'], // English practice
      right: '✅ 對！「The fitting room is at the back.」', // English practice
      wrong: '嗯，用「Can I…?」開頭吧。',
    },
    tattoo: {
      text: '一間刺青店。真正的刺青只有成年人（18歲以上）可以刺……不過刺青師說可以在你手上畫一顆暫時的星星！',
      get: '⭐ 暫時的星星（10枚金幣）',
      done: 'A sparkly star on your hand! “Temporary” means it washes off in a few days.', // English practice
    },
    sticker: {
      text: '大頭貼機！選一個相框，擺個姿勢。30枚金幣。',
      frames: ['🌸 花朵', '🐱 貓耳朵', '✨ 閃亮亮'],
      cheese: 'Say cheese!', // English practice
      done: '喀擦！貼紙出來了：大眼睛、亮晶晶，還有你最燦爛的笑容。',
    },
    busker: {
      dancer: '一位街舞舞者跟著音樂跳 popping、轉圈圈。大家圍成一圈看。',
      singer: '一位歌手彈著吉他唱著溫柔的歌。大家跟著搖擺，用手機錄影。',
      none: '現在沒有人表演。西門町的街頭藝人要有證照才能表演；他們從接近中午表演到晚上。',
      watch: '👀 看表演',
      tip: '🪙 打賞10枚金幣',
      cheer: 'That was amazing!', // English practice
      watched: '👏 你跟著大家一起拍手！',
      thanks: 'The performer bows: “Thank you so much!”', // English practice
    },
    screen: {
      text: 'The giant screen flashes adverts all day: a concert, a new game, and a bubble tea ad that says “BUBBLE TEA NT$50”.', // English practice
      q: 'How much is the bubble tea in the ad?', // English practice
      a: ['Fifty dollars.', 'Fifteen dollars.', 'Five hundred dollars.'], // English practice
      right: '✅ 答對了：fifty（50）。小心：fifteen 是15！',
      wrong: '再看一次：5和0……',
    },
    plaque: {
      text: '「西門」就是西邊的城門：以前臺北城牆的西門就在這附近。西門町就是「西門的街區」。',
      phrase: 'Ximending means West Gate District.', // English practice
    },
    graffiti: {
      text: '在台北電影主題公園，這面牆是可以合法塗鴉的：藝術家常常畫上新的作品。',
      q: 'What colour is the word 西門?', // English practice
      a: ['Pink.', 'Green.', 'Black.'], // English practice
      right: '✅ 對，是亮粉紅色！',
      wrong: '看看左邊第一幅作品！',
    },
    redHouse: {
      text: '西門紅樓建於1908年，是臺灣第一座公營市場。前面是八角形的樓，後面是十字形的大廳。現在裡面有很多年輕設計師的小店。',
      q: 'How many sides does an octagon have?', // English practice
      a: ['Eight.', 'Six.', 'Ten.'], // English practice
      right: '✅ 八個！「Octo」就是八——就像有八隻腳的章魚 octopus。',
      wrong: '數數看前面那棟樓有幾個邊！',
    },
    market: {
      text: '週末創意市集：手作鑰匙圈、明信片、飾品和茶。',
      q: 'You like a keychain. What do you say?', // English practice
      a: ['How much is this keychain?', 'Keychain money you?', 'I am a keychain.'], // English practice
      right: '✅ 「It’s 30 dollars. I made it myself!」', // English practice
      wrong: '試試看「How much is…?」',
      buy: '🔑 買鑰匙圈（30枚金幣）',
      bought: '你買了一個手作鑰匙圈！',
    },

    // --- 龍山寺 ---------------------------------------------------------------------------
    mrtL: {
      text: '捷運龍山寺站。出口就在艋舺公園裡，龍山寺就在馬路對面。',
      ride: '🚇 搭捷運',
    },
    etiquette: {
      intro: '進去之前，志工要確認你知道廟裡的禮儀。',
      qs: [
        { q: 'Which door do you use to go IN?', a: ['The right door — the Dragon Door.', 'The middle door.', 'The left door — the Tiger Door.'] }, // English practice
        { q: 'And which door do you use to go OUT?', a: ['The left door — the Tiger Door.', 'The Dragon Door again.', 'Through the window.'] }, // English practice
        { q: 'Can you step on the wooden door sill?', a: ['No, step over it.', 'Yes, jump on it.', 'Sit on it.'] }, // English practice
      ],
      right: '✅ 答對了！',
      wrong: '❌ 不太對。記住：龍門進，虎門出！',
      done: 'Well done! “Enter by the right door (dragon side), exit by the left (tiger side).” The middle door is for the gods.', // English practice
    },
    pillar: {
      text: '正門前有一對難得的銅鑄龍柱：每根柱子上都有一條龍盤繞到屋頂。',
      q: 'What are these pillars made of?', // English practice
      a: ['Bronze — a metal.', 'Wood.', 'Chocolate.'], // English practice
      right: '✅ 是銅！輕輕摸摸看：涼涼的、滑滑的。',
      wrong: '嗯，它們又黑又亮，像舊銅板一樣……',
    },
    waterfall: {
      text: '廟的入口有一座小瀑布流進錦鯉池。流水的聲音讓大家在拜拜前心情平靜下來。',
      phrase: 'The water sounds so peaceful.', // English practice
    },
    burner: {
      text: '天公爐是拜玉皇大帝——天上的神明。大家雙手拿香，拜三下，然後在心裡許個願。',
      bow: '🙏 拜三下，許個願',
      wish: 'I wish my family good health.', // English practice
      done: '你拜了三下。香煙帶著你的願望飄向天空。',
    },
    offer: {
      text: '獻給神明的水果、鮮花和糕點。鳳梨很受歡迎：台語的「鳳梨」（ông-lâi）聽起來像「旺來」，好運要來了！',
      q: 'Which fruit is yellow, spiky and sweet?', // English practice
      a: ['A pineapple.', 'A banana.', 'A grape.'], // English practice
      right: '✅ 是鳳梨！旺來——好運要來了！',
      wrong: '刺刺的……黃色的……',
    },
    moon: {
      text: '擲筊（台語「跋桮」）：在心裡問神明一個「是或不是」的問題，然後把兩個紅色的月牙形筊杯丟到地上。',
      throw: '🌙 問一個問題，擲筊',
      results: [
        { name: '聖筊', text: '一平一凸：答案是「是」！', en: 'The answer is yes!' }, // English practice
        { name: '笑筊', text: '兩個都是平面朝上：神明在笑。你的問題不夠清楚——再問一次！', en: 'Please ask again.' }, // English practice
        { name: '陰筊', text: '兩個都是凸面朝上：答案是「不是」，或是「現在還不行」。', en: 'The answer is no.' }, // English practice
      ],
      again: '🌙 再擲一次',
    },
    sticks: {
      text: '求籤：搖一搖竹籤筒，直到一支有號碼的籤掉出來，再到小抽屜裡找它的籤詩。',
      shake: '🎋 搖籤筒',
      got: '第{n}號籤掉出來了！你的籤詩說：',
      fortunes: [
        'Slow and steady wins the race. Keep going!', // English practice
        'A good friend will help you very soon.', // English practice
        'Be brave and say hello: a new friend is waiting.', // English practice
        'Your hard work will grow like a tree.', // English practice
        'Share what you have, and happiness comes back to you.', // English practice
        'Listen carefully today: you will learn something important.', // English practice
        'After the rain comes the rainbow.', // English practice
        'Your family is proud of you.', // English practice
      ],
    },
    roof: {
      text: '抬頭看！屋脊的兩端像燕子的尾巴一樣翹起來（燕尾脊）。屋脊上有很多用碎彩色瓷片做成的龍和小人偶（剪黏）。',
      q: 'What bird do the roof ends look like?', // English practice
      a: ['A swallow.', 'A penguin.', 'A chicken.'], // English practice
      right: '✅ 燕子！所以叫做燕尾脊。',
      wrong: '一種尾巴分岔的小鳥……',
    },
    herbTea: {
      vendor: 'Herbal tea! It cools you down. Hot or cold?', // English practice
      ok: 'A cup of cold herbal tea, please.', // English practice
      bad: ['Herb me cold!', 'I am a herbal tea.'], // English practice
      done: 'Here you go. It’s a little bitter, but perfect on a hot day!', // English practice
    },
    herbSign: {
      text: '青草巷：一百多年來，這些店都在賣新鮮的青草，用來煮青草茶和做傳統的偏方。',
      phrase: 'These herbs smell fresh.', // English practice
    },
    bopiliao: {
      text: '剝皮寮是臺北保存得最好的老街之一：有清朝和日治時期的紅磚店屋，還有遮雨的騎樓。',
      q: 'What are the old buildings made of?', // English practice
      a: ['Red bricks.', 'Glass.', 'Snow.'], // English practice
      right: '✅ 紅磚！騎樓還可以擋太陽和雨。',
      wrong: '看看牆壁：是紅色的……',
    },
    huaxi: {
      text: '華西街夜市是臺北最老的夜市之一，華麗的紅色牌樓後面是一條有屋頂的街。攤販傍晚才開。',
    },
    hxNoodle: {
      vendor: 'Danzai noodles! Small bowls, big taste. How many?', // English practice
      ok: 'One bowl of danzai noodles, please.', // English practice
      bad: ['Noodle one me!', 'I would like a bowl of chopsticks.'], // English practice
      done: 'Here you are! Shrimp, pork and a little egg on top.', // English practice
    },
    hxSoup: {
      vendor: 'Four-herb soup, nice and warm. Want one?', // English practice
      ok: 'Can I have a four-herb soup, please?', // English practice
      bad: ['Soup! Give!', 'I am four herbs.'], // English practice
      done: 'Here! It’s good for your tummy.', // English practice
    },
    chess: {
      text: '兩位阿公在榕樹下下象棋。旁邊一群人圍著看，還一直出主意，雖然沒人問他們！',
      q: 'In chess, what do you say when you attack the king?', // English practice
      a: ['Check!', 'Hello!', 'Goodbye!'], // English practice
      right: '✅ 「Check!」阿公笑著說：「Your move!」', // English practice
      wrong: '是一個很短的字……開頭是「ch」。',
    },
    pigeons: {
      text: '一群鴿子在公園裡啄來啄去，然後一起飛起來。',
      q: 'Count them in English! How many pigeons?', // English practice
      a: ['Eleven.', 'Seven.', 'Twenty.'], // English practice
      right: '✅ 十一隻！數得很好。',
      wrong: '再慢慢數一次！',
    },
    canoe: {
      text: '「艋舺」是萬華的舊名，來自凱達格蘭語的「獨木舟」。很久以前，人們划著獨木舟沿著這裡的河做生意。',
      phrase: 'Bangka means canoe.', // English practice
    },
    fortune: {
      text: '算命阿公看了看你的手，笑了。',
      reads: [
        'You will learn a lot of English this year.', // English practice
        'You have a kind heart. People like to be near you.', // English practice
        'Something you lost will come back to you.', // English practice
        'A trip will bring you a happy surprise.', // English practice
      ],
      thanks: 'Thank you, grandpa!', // English practice
    },
    oldIce: {
      vendor: 'Welcome to our old ice shop! Since 1960! What would you like?', // English practice
      ok: 'One bowl of fruit shaved ice, please.', // English practice
      bad: ['Ice fruit me now!', 'I would like a hot snowman.'], // English practice
      done: 'Here you go! Mango, watermelon and pineapple on fluffy ice.', // English practice
    },

    // --- 人物 -----------------------------------------------------------------------------
    talk: {
      xm_teen1: ['我們在等朋友。大家都約在6號出口！', '英文練習：「I’m here! Where are you?」', '等一下我們要去買珍奶。當然是半糖！'],
      xm_teen2: ['我朋友又遲到了……她說「I’m on my way!」', '西門町是拍照最好的地方。你看那些霓虹燈！'],
      xm_teen3: ['你拍過大頭貼了嗎？眼睛會變得超大！', '英文練習：「Let’s take a selfie!」'],
      xm_shopper1: ['這些球鞋在特價：買一送一！', '英文練習：「It’s on sale!」就是比平常便宜的意思。'],
      xm_shopper2: ['我收集球鞋。我有三十雙！', '這裡的店很晚才開——大概十一點——也很晚才關。'],
      xm_skater: ['台北電影主題公園是最棒的滑板場。而且還可以在牆上塗鴉！', '英文練習：「Watch this trick!」'],
      xm_artist: ['我的鑰匙圈都是手工做的。每一個都不一樣！', '星期六或星期天再來逛創意市集吧。'],
      xm_redGuide: ['西門紅樓1908年開幕的時候是市場。後來變成戲院，還當過電影院！', '英文練習：「octagon」＝8個邊，「cross」＝✚。'],
      xm_cosplayer: ['我今天打扮成我最喜歡的動漫英雄！', '英文練習：「Can I take a photo with you?」——「Sure!」'],
      xm_grandpaX: ['我年輕的時候，西門町有二十幾家電影院！', '電影街現在還有老戲院。孩子，電影是很神奇的。'],
      xm_volunteer: [],
      xm_fortuneGrandpa: [],
      xm_worshipper1: ['我每個星期天都來這裡為家人祈福。', '英文練習：「I pray for good health.」'],
      xm_worshipper2: ['艋舺龍山寺快三百年了。它建於1738年！', '這裡有很多神明：觀音、媽祖，還有保佑考試的神喔！'],
      xm_incenseAuntie: ['拜拜用的香和花！今天的花很新鮮喔。', '英文練習：「Would you like some incense?」'],
      xm_chess2: ['噓……他應該走馬才對！不要跟他說是我講的。', '象棋的棋子是圓的，上面寫著字。'],
      xm_pigeonKid: ['有人跑的時候，鴿子會一起飛起來！噓，慢慢走。', '英文練習：「Look! They’re flying!」'],
      xm_bopiliaoGuide: ['我在研究萬華的歷史。這裡以前是臺北最熱鬧的港口！', '因為這條街看起來很古老，很多電影都在這裡拍。'],
      xm_nightVendor: ['夜市五點開。肚子餓了再來！', '英文練習：「What do you recommend?」——「The danzai noodles!」'],
      xm_taichi: ['每天早上打太極讓我保持年輕！慢慢地……吸氣。', '英文練習：「Breathe in… breathe out.」'],
    },
    tourist: {
      ask: 'Excuse me! How do I get to the Red House?', // English practice
      a: ['Cross Chengdu Road. It’s on the other side, near Exit 1.', 'Turn into a cinema and jump.', 'I am the Red House.'], // English practice
      right: '✅ “Thank you so much! You speak great English!”', // English practice
      wrong: '觀光客看起來很困惑。再試一次！',
    },
    tourist2: {
      ask: 'Excuse me, which door do I use to go into the temple?', // English practice
      a: ['The right door — the Dragon Door.', 'The middle door, it’s the biggest.', 'Any window is fine.'], // English practice
      right: '✅ “The Dragon Door, thank you! And out by the Tiger Door?” — “Yes!”', // English practice
      wrong: '嗯……記住龍和虎！',
    },
    chessTalk: '“Your move!” The grandpa waits for you to watch closely.', // English practice
    incenseBuy: '🌸 買香（5枚金幣）',
    incenseBought: '你買了三支香。拿去天公爐拜拜吧！',
  },
};
